<template>
  <div v-on-click-outside="() => (showMenu = false)" class="relative">
    <primary-button
      class="h-10"
      :disabled="disabled"
      @click="handleButtonClick"
    >
      <div v-if="loading">
        <loader :is-loading="loading" />
      </div>
      <span v-else class="mr-6">
        {{ $t("ORCHESTRATION.RUN_ORCH") }}
      </span>
    </primary-button>

    <div
      data-cy="templates-dropdown"
      class="absolute top-0 right-0 flex h-10 w-10 transform cursor-pointer items-center justify-center rounded-r transition-all"
      :class="{
        'bg-blue-800': showMenu,
        'pointer-events-none cursor-not-allowed': disabled,
      }"
      @click="showMenu = !showMenu"
    >
      <icon-base
        class="translate-x-0.5 translate-y-1 transform text-white"
        :icon="IconArrowUp"
      />
    </div>

    <run-deals-do-templates-menu
      v-if="showMenu"
      :show="showMenu"
      @template:select="execute"
    />
  </div>
</template>

<script setup lang="ts">
import { type PropType, computed, ref } from "vue";

import { usePromiseWrapper } from "@/hooks/common";
import { useDealsControlPanelStore } from "@/stores/dealsControlPanel";

import RunDealsDoTemplatesMenu from "@/components/deals/dataOrchestration/run/RunDealsDoTemplatesMenu.vue";
import IconArrowUp from "@/components/icons/IconArrowUp.vue";

import type { IOrchestrationTemplate } from "@/models/orchestration";

const props = defineProps({
  applicationIds: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const emit = defineEmits<{
  "run:execute": [];
}>();

const dealsControlPanelStore = useDealsControlPanelStore();

const showMenu = ref(false);

const disabled = computed(() => !props.applicationIds.length || loading.value);

const { fetchWrapper: execute, loading } = usePromiseWrapper(
  async (template: IOrchestrationTemplate) => {
    showMenu.value = false;
    await dealsControlPanelStore.runDoTemplateAgainstDeals(
      props.applicationIds,
      template.id
    );
    emit("run:execute");
  }
);

const handleButtonClick = () => {
  if (disabled.value) {
    return;
  }

  showMenu.value = !showMenu.value;
};
</script>
